import Grid from "@material-ui/core/Grid";
import {
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Switch,
  Typography,
} from "@material-ui/core";
import { ArrowBackIos } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import SlideCard from "../../SlideCard";
import HeavyItemCard from "./HeavyItemCard";
import i18n from "../../../../i18nextInitiator";
import { connect } from "react-redux";
import { hasHeavyItem } from "../../../../actions/actionCreators";
import { Alert } from "@material-ui/lab";

const mapStateToProps = (state) => ({ ...state.order });
const useStyles = makeStyles((theme) => ({
  root: {
    padding: "0 20px",
    maxWidth: 600,
    margin: "0 auto",
    "& > *": {
      margin: ".8rem 0",
    },
    "& button": {
      boxShadow: "unset",
    },
    "& *:focus": {
      outline: 0,
    },
  },
  paper: {
    backgroundColor: theme.palette.primary.light,
    borderRadius: ".3rem",
    border: `solid 1px ${theme.palette.primary.border}`,
    padding: ".5rem",
    width: "100%",
    zIndex: 1,
    boxShadow: "none",
    minHeight: "4rem",
  },
  tabSelected: {
    color: "white",
  },
  tabIndicator: {
    height: "100%",
    zIndex: -1,
    borderRadius: 8,
    // boxShadow: `0 0 5px 2px rgba(25, 39, 131, 0.24)`
  },
  serviceSubtitle: {
    fontWeight: 900,
  },
  box: {
    margin: ".3rem 0",
  },
  notExist: {
    marginTop: "10px",
  },
}));
const t = i18n.getFixedT("fa", "general");

const HeavyItems = (props) => {
  const classes = useStyles();
  const { order: { vasayeleHazinedar: heavyItems = [] } = {} } = props;

  const [showHeavy, setShowHeavy] = useState(false);

  /**
   * filters the element with count and sorts the array based on view property.
   * @type {*[]}
   */
  const chosenHeavyItems = heavyItems
    .filter((obj) => obj.count > 0)
    .sort((a, b) => (a.view_priority > b.view_priority ? 1 : -1));
  /**
   * Display Heavy Items.
   */
  const displayHeavy = () => {
    if (!showHeavy) setShowHeavy(true);
  };
  return (
    <>
      <Button className={classes.paper} onClick={displayHeavy}>
        <Grid xs={12} item>
          <Grid justifyContent={"space-between"} container>
            <Grid item>
              <Typography>{t("heavy-items")}</Typography>
            </Grid>
            <Grid item>
              <Typography>
                {t(`select`)}
                <ArrowBackIos />
              </Typography>
            </Grid>
          </Grid>
          <Grid container>
            {chosenHeavyItems.map((item, index) => {
              return (
                <div key={index}>
                  <Typography component={"span"} variant={"subtitle2"}>
                    {item.title} × {item.count}
                  </Typography>
                  {index + 1 !== chosenHeavyItems.length && (
                    <Typography
                      component={"span"}
                      variant={"button"}
                      color={"primary"}
                    >
                      &nbsp;+&nbsp;
                    </Typography>
                  )}
                </div>
              );
            })}
          </Grid>
        </Grid>
      </Button>
      {!hasHeavyItem() && (
        <Grid xs={12}>
          <FormGroup className={classes.notExist}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={props.confirm}
                  onChange={props.onConfirmChange}
                />
              }
              label="تایید عدم وجود اقلام سنگین"
            />
          </FormGroup>
        </Grid>
      )}
      {!hasHeavyItem() && !props.confirm && props.showAlert && (
        <Grid xs={12}>
          <Alert severity="error">
            لطفا اقلام سنگین خود را انتخاب کنید یا عدم وجود را تایید کنید
          </Alert>
        </Grid>
      )}
      <SlideCard
        show={showHeavy}
        title={t("heavy-items")}
        close={() => setShowHeavy(false)}
      >
        <HeavyItemCard close={() => setShowHeavy(false)} />
      </SlideCard>
    </>
  );
};

export default connect(mapStateToProps)(HeavyItems);
